import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PublicLayout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Search, MapPin } from "lucide-react";
import { ProCard } from "@/pages/Home";

const CITIES = ["Santos","Praia Grande","São Vicente","Guarujá","Cubatão","Bertioga","Mongaguá","Itanhaém","Peruíbe"];

export default function Busca() {
  const [sp, setSp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q")||"");
  const [city, setCity] = useState(sp.get("city")||"");
  const [specialty, setSpecialty] = useState(sp.get("specialty")||"");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/professionals",{params:{q: q||undefined, city: city||undefined, specialty: specialty||undefined}})
      .then(r=>setResults(r.data)).finally(()=>setLoading(false));
  };

  useEffect(() => { load(); }, [sp]);

  const apply = (e) => {
    e?.preventDefault();
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (city) p.set("city", city);
    if (specialty) p.set("specialty", specialty);
    setSp(p);
  };

  return (
    <PublicLayout>
      <div className="bg-[#074E41] text-white py-10">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-3xl font-extrabold" style={{fontFamily:"Plus Jakarta Sans"}}>Buscar profissionais</h1>
          <form onSubmit={apply} className="mt-6 bg-white rounded-2xl p-2 grid sm:grid-cols-[1fr,220px,220px,auto] gap-2 gs-shadow-lg">
            <div className="flex items-center gap-2 px-3">
              <Search className="w-4 h-4 text-slate-400"/>
              <Input data-testid="busca-q" value={q} onChange={e=>setQ(e.target.value)} placeholder="Nome, profissão ou especialidade" className="border-0 focus-visible:ring-0 text-slate-900"/>
            </div>
            <div className="flex items-center gap-2 px-3 border-l border-slate-200">
              <MapPin className="w-4 h-4 text-slate-400"/>
              <select data-testid="busca-city" value={city} onChange={e=>setCity(e.target.value)} className="w-full py-2 bg-transparent text-slate-900 focus:outline-none">
                <option value="">Cidade</option>
                {CITIES.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div className="flex items-center gap-2 px-3 border-l border-slate-200">
              <Input data-testid="busca-specialty" value={specialty} onChange={e=>setSpecialty(e.target.value)} placeholder="Especialidade" className="border-0 focus-visible:ring-0 text-slate-900"/>
            </div>
            <Button data-testid="busca-submit" type="submit" className="bg-[#FF7D54] hover:bg-[#e56a44]">Buscar</Button>
          </form>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-5">
          <div className="text-sm text-slate-600">{loading? "Buscando..." : `${results.length} resultado(s)`}</div>
        </div>
        {results.length === 0 && !loading && (
          <div className="text-center py-16 text-slate-500">Nenhum profissional encontrado. Tente ajustar os filtros.</div>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {results.map(p => <ProCard key={p.id} p={p}/>)}
        </div>
      </div>
    </PublicLayout>
  );
}
